







import React from "react";
import { Link } from "react-router-dom";
import "../styles/ManagementStandardsVision.css";

// Import your icon and image
import managementIcon from "../assets/icons/management-icon.png";
import managementImage from "../image/Management-image.png";

const ManagementStandardsVision = () => {
  return (
    <div className="msv-container">
      {/* Image Slider */}
      <div className="msv-image-slider">
        <img src={managementImage} alt="Management Standards Vision Slider" />
      </div>

      {/* Main Content Container */}
      <div className="msv-content">
        {/* Content Card with title inside */}
        <div className="msv-card">
          {/* Ship wheel icon and title */}
          <div className="msv-header-container">
            <img src={managementIcon} alt="Management" className="msv-wheel-icon" />
            <div className="msv-header-title">Management, Standards & Vision</div>
          </div>
          
          {/* Content */}
          <div className="msv-text-content">
            <p className="msv-text">
             The top management of ECL Shipping brings together over ten decades of combined experience in the shipping industry. The company considers its people as its greatest strength, combining skills, experience, teamwork, and focus to consistently deliver quality services. With this approach, ECL Shipping strives to be its clients’ trusted Partner of Choice.
            </p>
            
            <p className="msv-text">
             ECL Shipping is committed to the highest safety standards for all cargo carried on its vessels, with a firm “Safety First” philosophy at the core of its operations. Years of experience, innovative practices, and in-depth cargo analysis have enabled the company to develop standardized procedures for handling diverse cargo types, ensuring reliability and compliance for clients of international repute.
            </p>
            
            <p className="msv-text">
              Built on a reputation for seamless service, strict schedule adherence, and operational flexibility, ECL Shipping delivers safe and dependable transportation solutions. Guided by strong business ethics, continuous improvement, and hands-on knowledge of ships, cargoes, and ports, the company strengthens its brand through long-term relationships, driven by the vision to serve <b>“Every Freight, Everywhere.”</b>
            </p>
            
           
          </div>
          
          {/* Right Side Panel */}
          <div className="msv-side-panel">
            <Link to="/overview" className="msv-panel-link">
              <div className="msv-panel-section">
                <h4 className="msv-panel-title">Overview :</h4>
                <p className="msv-panel-text">
                 ECL Shipping India Pvt Ltd was established in 2025 as a joint venture of ECL (Singapore) Pte Ltd, a 100 percent subsidiary of M/s. Eastern Car Liner, Japan.
ECL-Shipping acts as the General Agent in India for M/s. Eastern Car Liner, one of the largest breakbulk operators from Japan.

                </p>
              </div>
            </Link>
            
            <Link to="/joint-venture-partners" className="msv-panel-link">
              <div className="msv-panel-section">
                <h4 className="msv-panel-title">Joint Venture Partners :</h4>
                <p className="msv-panel-text">
                 ECL Shipping India Pvt. Ltd. is associated with ECL (Singapore) Pte. Ltd., which is a major shareholder in the company. ECL (Singapore) Pte. Ltd. represents the ECL Group’s interests and plays a key role in supporting ECL Shipping’s operations in the region.
                </p>
              </div>
            </Link>
            
            {/* <Link to="/statistics" className="msv-panel-link">
              <div className="msv-panel-section">
                <h4 className="msv-panel-title">Statistics :</h4>
                <p className="msv-panel-text">
                  The Breakbulk and Project sailing services provided by ECL Shipping transcends all tangible targets set by themselves.
                </p>
              </div>
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementStandardsVision;